import {Stack, Typography} from '@mui/material';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import {Button} from '../components/Button';

export const ErrorScreen = () => {
  const navigate = useNavigate();
  return (
    <Stack alignItems="center" mt="100px">
      <Stack spacing={2} alignItems="center">
        <Typography
          color="flikGray.-20"
          sx={{fontSize: '160px', fontWeight: 'bold'}}>
          Error
        </Typography>
        <Typography sx={{fontSize: '20px', fontWeight: 'bold'}}>
          システムエラーが発生しました
        </Typography>
        <Typography>
          ページを更新するか、しばらく時間をおいてからお試しください。
        </Typography>
      </Stack>
      <Button
        variant="contained"
        sx={{mt: '46px'}}
        onClick={() => navigate('/')}>
        トップページ
      </Button>
    </Stack>
  );
};
